import type { Translations } from './zh';

export const ru: Translations = {
  bubble: {
    open: 'Открыть чат',
    close: 'Закрыть чат',
    badge: 'В сети',
    dragHint: 'Нажмите и удерживайте, чтобы перетащить',
  },
  panel: {
    closeAria: 'Закрыть панель чата',
    languageAria: 'Выбрать язык',
    welcomeFallback: 'Здравствуйте! Чем я могу помочь?',
    quickQuestionsTitle: 'Вы можете задать мне следующие вопросы',
    quickAskTitle: 'Быстрые вопросы',
    inputPlaceholder: 'Введите ваш вопрос...',
    sendButton: 'Отправить',
    sendAria: 'Отправить сообщение',
    onlineStatus: 'В сети',
    thinkingAria: 'Думает',
    aiBusyHint: 'Оператор отвечает, подождите…',
    leadReopenHint: 'При необходимости оставьте здесь контактные данные',
    startChat: 'Начать консультацию',
    welcomeQuickHint: 'Быстрый обзор',
    videoPreparing: 'Видео готовится…',
    newMessageTitle: '💬 Новое сообщение',
    newMessageBody: 'У вас есть новое сообщение. Нажмите, чтобы просмотреть.',
  },
  roles: {
    visitor: 'Посетитель',
    ai: 'ИИ-ассистент',
    human: 'Оператор',
    system: 'Система',
  },
  web: {
    aiChat: 'ИИ-поддержка',
    humanChat: 'Оператор',
    switchToHuman: 'Связаться с оператором',
    switchToAI: 'Вернуться к ИИ',
    resetChat: 'Начать заново',
    commonQuestions: 'Частые вопросы',
    faqTitle: 'Часто задаваемые вопросы',
    selectLanguage: 'Выбрать язык',
    maximize: 'Развернуть',
    restore: 'Восстановить',
    offlineLabel: 'Не в сети',
    aiGreeting: 'Здравствуйте! Я ИИ-ассистент. Чем могу помочь?',
    humanGreeting: 'Здравствуйте! Вы соединены с оператором. Чем я могу вам помочь?',
    agentOffline: 'Оператор не в сети',
    agentOfflineMessage: 'К сожалению, операторы сейчас не в сети. Отсканируйте QR-код ниже, чтобы связаться с нами в WeChat.',
    wechatPrompt: 'Сканировать для WeChat',
    wechatHint: 'Отсканируйте QR-код в WeChat',
    serviceHoursLabel: 'Часы работы: ',
    viewImage: 'Посмотреть изображение',
    playVideo: 'Воспроизвести видео',
    closeViewer: 'Закрыть',
    downloadFile: 'Скачать',
    fileTypePdf: 'Документ PDF',
    fileTypeWord: 'Документ Word',
    fileTypeExcel: 'Таблица Excel',
    fileTypePpt: 'Презентация PowerPoint',
    fileTypeArchive: 'Архив',
    fileTypeGeneric: 'Файл',
  },
  leadCard: {
    ariaForm: 'Форма контактов',
    title: 'Оставьте свои контактные данные',
    nameLabel: 'Имя',
    namePlaceholder: 'Ваше имя',
    phoneLabel: 'Телефон',
    phonePlaceholder: 'Ваш номер телефона',
    phoneError: 'Введите корректный номер телефона',
    submit: 'Отправить',
    submitting: 'Отправка…',
    dismiss: 'Позже',
    success: 'Спасибо! Наш консультант свяжется с вами в ближайшее время.',
  },
};
